import type { DraftFamilyRow } from './table/rows';

// TODO: We have to revisit the code soon

const findFamilyByClusterId = (families: readonly DraftFamilyRow[], clusterId: string): DraftFamilyRow | undefined =>
    // biome-ignore lint/complexity/useOptionalChain: suppressed due to migration
    families.find((f) => f.subRows !== undefined && f.subRows.some((c) => c.id === clusterId));

export function computeDeselect(
    selectedIds: ReadonlySet<string>,
    id: string,
    workingData: readonly DraftFamilyRow[],
): ReadonlySet<string> {
    const next = new Set(selectedIds);
    next.delete(id);
    const family = workingData.find((f) => f.id === id);
    if (family?.subRows !== undefined) {
        for (const cluster of family.subRows) {
            next.delete(cluster.id);
        }
    } else {
        const clusterParent = findFamilyByClusterId(workingData, id);
        if (clusterParent !== undefined) {
            const cluster = clusterParent.subRows?.find((c) => c.id === id);
            if (cluster?.status === 'removed') {
                next.delete(clusterParent.id);
            }
        }
    }

    return next;
}

export function computeSelect(
    selectedIds: ReadonlySet<string>,
    id: string,
    workingData: readonly DraftFamilyRow[],
): ReadonlySet<string> {
    const next = new Set(selectedIds);
    next.add(id);
    const family = workingData.find((f) => f.id === id);
    if (family?.subRows !== undefined) {
        for (const cluster of family.subRows) {
            next.add(cluster.id);
        }
    } else {
        const clusterParent = findFamilyByClusterId(workingData, id);
        const cluster = clusterParent?.subRows?.find((c) => c.id === id);
        if (clusterParent !== undefined && cluster?.status !== 'removed') {
            next.add(clusterParent.id);
        }
    }

    return next;
}
